import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import {
  buildRainMonthFileName,
  exportRainMonthPdf,
  printRainMonthSheet,
} from "../../utils/rainMonthExport";
import RainMonthPrintSheet from "./RainMonthPrintSheet";
import RainSheetExportActions from "./RainSheetExportActions";

function RainMonthSheetModal({
  open,
  onClose,
  farmName,
  monthTitle,
  days,
  gauges,
  dailyByStation,
}) {
  const { t } = useTranslation();
  const [exportingPdf, setExportingPdf] = useState(false);
  const sheetRef = useRef(null);

  if (!open) return null;

  function handlePrint() {
    if (!sheetRef.current) return;
    if (!printRainMonthSheet(sheetRef.current)) {
      return;
    }
  }

  async function handleExportPdf() {
    if (!sheetRef.current || exportingPdf) return;
    setExportingPdf(true);
    try {
      await exportRainMonthPdf(
        sheetRef.current,
        buildRainMonthFileName({
          farmLabel: farmName,
          monthLabel: monthTitle,
        })
      );
      toast.success(t("PDF do mês salvo."));
    } catch (error) {
      toast.error(t("Não foi possível exportar o PDF do mês."));
    } finally {
      setExportingPdf(false);
    }
  }

  return (
    <section
      className="rain-month-sheet-panel"
      aria-labelledby="rain-month-sheet-title"
    >
      <div className="rain-month-sheet-panel__toolbar">
        <div>
          <h2 id="rain-month-sheet-title">{t("Planilha do mês")}</h2>
          <p>
            {farmName}
            {" · "}
            {monthTitle}
            {" · "}
            {(days || []).length} {t("dias")}
          </p>
        </div>
        <div className="rain-month-sheet-panel__actions">
          <RainSheetExportActions
            onPrint={handlePrint}
            onExportPdf={handleExportPdf}
            exportingPdf={exportingPdf}
          />
          <button type="button" className="btn btn-default btn-sm" onClick={onClose}>
            {t("Fechar")}
          </button>
        </div>
      </div>
      <div ref={sheetRef} className="rain-month-sheet-panel__sheet">
        <RainMonthPrintSheet
          farmName={farmName}
          monthTitle={monthTitle}
          days={days}
          gauges={gauges}
          dailyByStation={dailyByStation}
        />
      </div>
    </section>
  );
}

export default RainMonthSheetModal;
